import React from "react"
import "./Locations.scss"
import "../SchedulePages/SchedulePage.desktop.scss"
import "../SchedulePages/SchedulePage.mobile.scss"
import { CanadaLocations, ColoradoLocations, MNWLocations } from "./locations"
import { NotificationConsumer } from "ibe-components"
import ErrorBoundary from "../../atoms/ErrorBoundary"
import TabNavbarLayout from "../../layouts/TabNavbarLayout"
import { ScheduleLocation } from "../SchedulePages/Locations"
import Seo from "../../molecules/Seo"

const PickupLocationsPage = ({ history }) => {
  function gotoLocation(location) {
    history.push(location)
  }

  return (
    <NotificationConsumer>
      {({ actions }) => {
        return (
          <ErrorBoundary>
            <TabNavbarLayout
              pageLayoutBackground="#FFF"
              render={() => {
                return (
                  <>
                    <Seo
                      title="Locations | Landline"
                      description="Explore Landline's airport shuttle locations, including Denver, Fort Collins, Minneapolis, Duluth, and Fargo. Reliable, convenient, and seamless airport transfers."
                      canonicalUrl="https://landline.com/locations"
                    />

                    <div className="locations-container">
                      <h4 className="locations-container-title">Serving Colorado</h4>
                      {ColoradoLocations.map(location => {
                        return (
                          <ScheduleLocation
                            data={location}
                            onButtonClick={() => {
                              gotoLocation(location.url)
                            }}
                          />
                        )
                      })}
                      <h4 className="locations-container-title">Serving Canada</h4>
                      {CanadaLocations.map(location => {
                        return (
                          <ScheduleLocation
                            data={location}
                            onButtonClick={() => {
                              gotoLocation(location.url)
                            }}
                          />
                        )
                      })}
                      <h4 className="locations-container-title">Serving Minnesota</h4>
                      {MNWLocations.map(location => {
                        return (
                          <ScheduleLocation
                            data={location}
                            onButtonClick={() => {
                              gotoLocation(location.url)
                            }}
                          />
                        )
                      })}
                    </div>
                  </>
                )
              }}
            />
          </ErrorBoundary>
        )
      }}
    </NotificationConsumer>
  )
}

export default PickupLocationsPage
